<template>

<Layout>
  <!-- 去掉多余信息 -->
  <div slot="nav"></div>
  <div slot="sub-nav"></div>
  <div slot="footer-service"></div>
  <!-- 去掉多余信息 -->

  <div class="home">

  <!-- 导航栏 -->

  <!-- banner -->
    <div class="banner">
      <div class="container">
        <div class="banner-box">
        </div>
      </div>
    </div>
  <!-- banner -->

  <!-- 联创营 -->
    <div id="introduce" class="introduce">
      <div class="container">
        <com-title :titleInfo="data['introduce']['title']"></com-title>
        <!-- <p class="text"><span class="color">华为云“5G+X”联创营</span>，旨在与互联网行业客户及伙伴一起发挥各自技术优势，围绕 “<span class="color">云+AI+5G+X</span>”， 在 5G 游戏、智慧</p> -->
        <p class="text" v-html="data['introduce']['text']"></p>
      </div>
      <com-button style="margin: 0 auto" :selfClass="'red'" :width="'200'" :button-info="data['introduce']['button']">
      </com-button>
    </div>
  <!-- 联创营 -->

  <!-- 热点资讯 -->
    <div id="message" class="message">
      <div class="container">
        <com-title :titleInfo="data['message']['title']" />
        <div class="message-content flex-content">
          <com-card2 :card-info="msgItem" v-for="(msgItem, msgIndex) in (showListKey.messageShow ? messageList : messageList.slice(0,4))" :key="msgItem + '-' + msgIndex" />
        </div>
        <div v-if="!showListKey.messageShow && (messageList.length > 4)" @click="showList('messageShow')">
          <com-button style="margin: 0 auto" :selfClass="'red'" :width="'200'" :button-info="data['message']['button']">
          </com-button>
        </div>
      </div>
    </div>
  <!-- 热点资讯 -->

  <!-- 大咖观点 -->
    <div id="viewpoint" class="viewpoint">
      <div class="container">
        <com-title :titleInfo="data['viewpoint']['title']" :topic="'white'" />
        <div class="content">
          <swiper :options="swiperOption1">
            <swiper-slide class="swiper-slide" v-for="(item, index) in viewpointList" :key="index + 'viewpoint'">
                <a :href="item.videoSrc" target="_blank" class="left">
                  <span class="play"></span>
                  <img class="img" :src="item.imgSrc" alt="">
                </a>
                <div class="right">
                  <span class="double"></span>
                  <p class="text">{{item.text}}</p>
                  <div class="info-box">
                    <span class="name">{{item.name}}</span>
                    <span class="position">{{item.position}}</span>
                  </div>
                </div>
            </swiper-slide>
            <!-- 分页器 -->
            <div class="swiper-pagination"  slot="pagination"></div>
            <!-- 左右箭头 -->
            <div v-if="!isMobile" class="swiper-button-prev" slot="button-prev"></div>
            <div v-if="!isMobile" class="swiper-button-next" slot="button-next"></div>
          </swiper>
        </div>
      </div>
    </div>
  <!-- 大咖观点 -->

  <!-- 精彩活动 -->
    <div id="activity" class="activity">
      <div class="container">
        <com-title :titleInfo="data['activity']['title']" />
        <div class="content">
          <com-card3 :card-info="actItem" v-for="(actItem, actIndex) in (showListKey.activityShow ? activityList : activityList.slice(0,5))" :key="actItem + '-' + actIndex"/>
        </div>
        <div v-if="!showListKey.activityShow  && (activityList.length > 5)" @click="showList('activityShow')">
            <com-button style="margin: 0 auto" :selfClass="'red'" :width="'200'" :button-info="data['message']['button']">
            </com-button>
        </div>
      </div>
    </div>
  <!-- 精彩活动 -->

  <!-- 创联场景 -->
    <div id="scene" class="scene">
      <div class="container">
        <com-title :titleInfo="data['scene']['title']" />
        <div class="content">
          <com-card4 :card-info="sceneItem" v-for="(sceneItem, sceneIndex) in sceneList" :key="sceneItem + '-' + sceneIndex"/>
        </div>
      </div>
    </div>
  <!-- 创联场景 -->

  <!-- 服务 -->
    <div id="serve" class="serve">
      <div class="container">
        <com-title :titleInfo="data['serve']['title']" />
        <div class="content">
          <com-card5 :card-info="serveItem" v-for="(serveItem, serveIndex) in serveList" :key="serveItem + '-' + serveIndex"/>
        </div>
      </div>
    </div>
  <!-- 服务 -->

  <!-- 加入创联营 -->
    <div id="join" class="join">
      <div class="container">
        <com-title :titleInfo="data['join']['title']" :topic="'white'" />
        <div class="content">
          <h1 class="title">{{data['join']['content']['title']}}</h1>
          <div class="text-box">
            <p class="text" v-for="joinItem in joinList" :key="joinItem"><span class="sign"></span>{{joinItem}}</p>
          </div>
        </div>
        <com-button style="margin: 0 auto;" :selfClass="'normal'" :width="'200'" :button-info="data['join']['button']">
          <i slot="icon" class="iconfont iconarrow_forward_"></i>
        </com-button>
      </div>
    </div>
  <!-- 加入创联营 -->

  <edit :data="data" :debug="false"></edit>
  </div>
</Layout>
</template>

<script>
import data from '@/data'
import Edit from '@/components/edit'

import Layout from 'components/layout/Layout'

// import ComNav from '@/components/nav'
import ComTitle from '@/components/title'
// import ComCard1 from '@/components/card1'
import ComCard2 from '@/components/card2'
import ComCard3 from '@/components/card3'
import ComCard4 from '@/components/card4'
import ComCard5 from '@/components/card5'

import ComButton from '@/components/button1'
// import modal from '@/components/modal/modal'

// import LeftImgModule from '@/components/left-img'
// import ComFooter from '@/components/footer'

// import ComButton2 from '@/components/button2'

import { mapState } from 'vuex'

export default {
  components: {
    Layout,
    // LeftImgModule,
    // ComNav,
    ComTitle,
    // ComCard1,
    ComCard2,
    ComCard3,
    ComCard4,
    ComCard5,
    // ComFooter,
    ComButton,
    // modal,
    Edit
    // ComButton2
  },
  data () {
    return {
      data: data,
      isActive: false,
      nowVideoSrc: '',
      messageList: data['message']['list'],
      viewpointList: data['viewpoint']['list'],
      activityList: data['activity']['list'],
      sceneList: data['scene']['list'],
      serveList: data['serve']['list'],
      joinList: data['join']['content']['list'],
      showListKey: {
        messageShow: false,
        activityShow: false
      },
      swiperOption1: {
        draggable: false,
        speed: 1000,
        // grabCursor: true,
        loop: true,
        effect: 'fade',
        fadeEffect: {
          crossFade: false
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: false
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        autoplay: {
          delay: 8000,
          disableOnInteraction: false,
          waitForTransition: true
        }
      }
    }
  },
  computed: {
    ...mapState(['isMobile'])
  },
  methods: {
    showList (prop) {
      this.showListKey[prop] = true
    },
    playVideo (src) {
      this.isActive = true
      this.nowVideoSrc = src
    }
  },
  mounted () {
    if (this.$route.hash) {
      setTimeout(() => {
        let top = document.querySelector(this.$route.hash).offsetTop - 20
        window.scrollTo(0, top)
      }, 300)
    }
  }
}
</script>

<style lang="scss">
@import '@/style/app.sass';

.home {
  background-color: #fff;
  font-family: PingFang SC;
}

.banner {
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('../../image/home/banner-bg-pc.png');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: 580px;
  @include mobile {
    height: 480px;
    background-image: url('../../image/home/banner-m.png');
    background-size: cover;
  }

  .banner-box {
    width: 64%;
    // height: 202px;
    padding-bottom: 18%;
    margin: 0 auto;
    background-image: url('../../image/home/banner-text-pc.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    @include mobile {
      display: none;
    }
  }
}

.introduce {
  background-image: url('../../image/home/module1-bg.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;
  text-align: justify;
  padding-bottom: 80px;
  @include mobile {
    padding-bottom: 40px;
  }

  .container {
    >.text {
      color: $font-color3;
      font-size: 18px;
      margin-bottom: 40px;
      >.color {
        color: $primary1;
        font-weight: 500;
      }
    }
  }
}

.message {
  background-color: #F6F7F8;
  overflow-x: hidden;
  padding-bottom: 80px;
  @include mobile {
    padding-bottom: 30px;
    margin-bottom: 0;
  }
  & .container {
    position: relative;
    .bg-right {
      position: absolute;
      right: -200px; top: 100px;
      width: 137px;
      @include mobile {
        display: none;
      }
    }
    & .message-content {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
    }
  }
}

.viewpoint {
  background: $primary1;
  padding-bottom: 80px;

  .container {
    display: flex;
    flex-direction: column;

    .content {
      position: relative;
      align-self: flex-end;
      width: 1088px;
      height: 315px;
      background: rgba(255,255,255,1);
      box-shadow: 0px 2px 7px 1px rgba(0, 0, 0, 0.05);
      border-radius: 5px;
      @include mobile {
        width: 100%;
        height: 410px;
        margin-top: 30px;
      }

      .swiper-container {
        position: absolute;
        top: 0;
        right: 0;
        width: 1140px;
        height: 100%;
        @include mobile {
          width: 100%;
          height: 470px;
          margin-top: -24px;
        }
      }

      .swiper-button-next {
        margin-right: 56px;
        margin-top: -28px;
        width: 26px;
        height: 55px;
        background: url('../../image/home/button.png');
        background-size: 100%;
        background-repeat: no-repeat;
        background-position: center;
        transform: rotate(180deg);
      }

      .swiper-button-prev {
        margin-left: 432px;
        margin-top: -28px;
        width: 26px;
        height: 55px;
        background: url('../../image/home/button.png');
        background-size: 100%;
        background-repeat: no-repeat;
        background-position: center;
      }

      .swiper-pagination-bullets {
        margin-left: 188px;
        margin-bottom: 20px;
        @include mobile {
          margin: 0;
          margin-bottom: -12px;
        }

        .swiper-pagination-bullet {
          width: 32px;
          height: 3px;
          background: rgba(0, 0, 0, 0.6);
          border-radius: 2px;
          @include mobile {
            background: rgba(0, 0, 0, 0.9);
          }
        }

        .swiper-pagination-bullet-active {
          background: $primary1;
          @include mobile {
            background: #fff;
          }
        }
      }

      .swiper-slide {
        display: flex;
        border-radius: 5px;
        @include mobile {
          flex-direction: column;
        }

        .left {
          font-size: 0;
          position: relative;
          background: #fff;
          align-self: center;
          border-radius:5px;
          @include mobile {
          }

          .img {
            width: 398px;
            height: 264px;
            border-radius:5px;
            @include mobile {
              width: 278px;
              height: 184px;
            }
          }

          .play {
            width: 50px;
            height: 50px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: url('../../image/home/play.png');
            background-size: 100%;
            background-repeat: no-repeat;
            background-position: center;
            cursor: pointer;
            @include mobile {
              width: 37px;
              height: 37px;
            }
          }
        }

        .right {
          background: #fff;
          padding: 38px 110px 0 100px;
          box-sizing: border-box;
          border-radius: 5px;
          @include mobile {
            padding: 30px 25px 0 25px;
          }

          .double {
            display: block;
            width: 30px;
            height: 25px;
            background: url('../../image/home/double.png');
            background-size: 100%;
            background-repeat: no-repeat;
            background-position: center;
            margin-bottom: 24px;
            @include mobile {
              width: 21px;
              height: 17px;
              margin-bottom: 12px;
            }
          }

          .text {
            font-size: 18px;
            font-weight: 400;
            color:rgba(12, 12, 12, 0.9);
            margin-bottom: 20px;
            @include limit-line-numbers(3);
            @include mobile {
              font-size: 14px;
              margin-bottom: 10px;
              @include limit-line-numbers(5);
            }
          }

          .info-box {
            text-align: right;
            .name {
              font-size: 20px;
              font-weight: 500;
              color: $primary1;
              margin-right: 18px;
              @include mobile {
                font-size: 14px;
              }
            }

            .position {
              font-size: 15px;
              font-weight: 400;
              color: $font-color2;
              @include mobile {
                font-size: 12px;
              }
            }
          }
        }
      }
    }
  }
}

.activity {
  background-color: #F6F7F8;
  background-image: url('../../image/home/activity-bg.png');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  padding-bottom: 80px;
  @include mobile {
    padding-bottom: 40px;
  }

  .content {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
    @include mobile {
      flex-direction: column;
      margin-bottom: 10px;
    }
  }
}

.scene {
  padding-bottom: 80px;
  @include mobile {
    padding-bottom: 40px;
  }

  .container {
    .content {
      display: flex;
      flex-wrap: wrap;
      @include mobile {
        flex-direction: column;
      }
    }
  }
}

.serve {
  padding-bottom: 80px;
  background: #F5FAFF;
  @include mobile {
    padding-bottom: 40px;
  }

  .container {
    .content {
      display: flex;
      flex-wrap: wrap;
      @include mobile {
        flex-direction: column;
      }
    }
  }
}

.join {
  padding-bottom: 80px;
  background: $primary1;
  @include mobile {
    padding-bottom: 40px;
  }
  .content {
    margin-bottom: 20px;
    .title {
      position: relative;
      font-size: 22px;
      font-weight: 500;
      color: #fff;
      line-height: 1;
      padding-bottom: 20px;
      @include mobile {
        font-size: 16px;
      }
      &::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 1px;
        background: rgba(255, 255, 255, 0.5);
      }
    }

    .text-box {
      display: flex;
      flex-wrap: wrap;
      margin-top: 30px;
      padding: 0 30px;
      @include mobile {
        flex-direction: column;
        padding: 0;
      }
      .text {
        width: 47%;
        font-size: 18px;
        color: #fff;
        box-sizing: border-box;
        line-height: 1;
        margin-bottom: 25px;
        &:nth-child(2n) {
          width: 53%;
        }
        @include mobile {
          width: 100% !important;
          margin-bottom: 14px;
          font-size: 14px;
        }

        .sign {
          display: inline-block;
          width: 6px;
          height: 6px;
          background: #fff;
          border-radius: 50%;
          margin-bottom: 3px;
          margin-right: 14px;
        }
      }
    }
  }
}
</style>
